module.exports = __webpack_public_path__ + "static/media/rub-out-the-write-word.bb2583ce.txt";